import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSubscription } from '../../../contexts/SubscriptionContext';
import styles from './StripeReturn.module.css';

// 'YYYY-MM-DD' ou 'YYYY-MM-DD HH:MM:SS' -> dia local, sem passar o texto ao Date
// (evita a véspera por fuso e o Invalid Date do Safari), como em SubscriptionDetails
const formatDate = (value) => {
  if (!value) return null;
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
};

/**
 * Aviso único conforme a situação da conta, com os dados de assinatura já
 * carregados pelo SubscriptionContext: plano pago continua, teste continua até a
 * data, ou sem acesso (escolher um plano para voltar a usar).
 */
const getMessage = ({ subscription, isInActiveTrial, hasActiveSubscription, trialInfo }) => {
  if (subscription?.has_active_plan) {
    return 'Nada mudou: seu plano atual continua como estava.';
  }
  if (isInActiveTrial()) {
    const endDate = formatDate(trialInfo?.trial_ends_at);
    return endDate
      ? `Nada mudou: seu teste continua até ${endDate}.`
      : 'Nada mudou: seu teste continua normalmente.';
  }
  if (hasActiveSubscription()) {
    return 'Nada mudou: seu plano atual continua como estava.';
  }
  return 'Escolha um plano para voltar a usar.';
};

/** Volta do checkout abandonado: nada foi cobrado, e o que vale agora. */
const Canceled = () => {
  const navigate = useNavigate();
  const { subscription, trialInfo, loading, isInActiveTrial, hasActiveSubscription } = useSubscription();

  const message = getMessage({ subscription, isInActiveTrial, hasActiveSubscription, trialInfo });

  return (
    <div className={`page-content ${styles.page}`}>
      <div className={styles.card}>
        <span className={`${styles.icon} ${styles.iconNeutral}`}><InfoOutlinedIcon fontSize="inherit" /></span>
        <h1 className={styles.title}>Nenhuma cobrança foi feita</h1>
        <p className={styles.text}>Você saiu do pagamento antes de concluir.</p>
        {loading ? (
          <Skeleton variant="rounded" height={48} sx={{ borderRadius: '12px' }} />
        ) : (
          <p className={styles.statusLine}>{message}</p>
        )}
        <div className={styles.actions}>
          <button type="button" className={styles.btnPrimary} onClick={() => navigate('/subscription/plans')}>
            Voltar aos planos
          </button>
        </div>
      </div>
    </div>
  );
};

export default Canceled;
